/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Integrations_Not_Connected_HintInputs */



/**
* | output |
* | --- |
* | "Connect an account below to let the assistant use this." |
*
* @param {My_Integrations_Not_Connected_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_not_connected_hint = /** @type {((inputs?: My_Integrations_Not_Connected_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Not_Connected_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Verbinden Sie unten ein Konto, damit der Assistent dies nutzen kann.")
	return /** @type {LocalizedString} */ ("Connect an account below to let the assistant use this.")
});